// mcn-frontend/src/components/sections/LandingFooter.jsx
//
// IMPORTANT: Thin wrapper around the shared layout Footer.jsx. Previously this
// rendered its own white footer which mismatched the dark slate footer on
// inner pages. We now delegate so homepage + every inner page share one
// footer source — edits flow through `components/layout/Footer.jsx` +
// `Footer.css`.
//
// ComponentRegistry passes `data` (parsed footer.json). The shared Footer
// expects `footerData`, so we rename.
import React from 'react';
import Footer from '../layout/Footer';

const LandingFooter = ({ data }) => {
  return <Footer footerData={data} />;
};

export default LandingFooter;
